import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

class About extends Component {
   render() {
      return (
         <FadeIn duration="1.2s" timingFunction="ease-out">
            <div className="row main">
               <div className="col-md-3">
                  <h3 className="about-title">Biography</h3>
               </div>
               <div className="col-md-9">
                  <p className="about-bio">Arianit H. Hetemi is a student with a great passion
                     about technology. He is currently attending Computer Science in the University
                     of Business and Technology. Since he was a teenager he wanted to get involved
                     into the world of technology. From his great passion and dedication that he has,
                     he’s always updated with new innovative and potential ideas and make
                     improvements using technology. From his great commitment and interest, he always
                     wanted to attend trainings, hackathons, and camps about technology.
                     <br/><br/>
                     He attented a lot of trainings but he distinguishes one called Techstitution
                     (http://techstitution.org/) sponsored by UNICEF in partnership with Open Data
                     Kosovo, in which through workshops youth people contribute to build digital
                     software for Kosovo institutions. From his dedication in this project in this
                     training, his platform was chosen to be the best one for that institution.
                     <br/><br/>In the other side he participated with his team “InoCoders” in a
                        challenge called "Ministry of Data" held in Zagreb, Croatia 2017, in which they
                        won a special prize with their idea for building an application to help farmers
                        with their works using Open Data in Kosovo. The project is called "Smart Farm"
                        and is under development. He worked as a mentor in Tech4Policy project sponsored
                        by EU commision in which he teached young people programming and software
                        development life cycle, besides this he’s been teaching also in Techstitution
                        Training cutting-edge technologies and sharing his knowledge to others.
                  </p>
               </div>
            </div>
         </FadeIn>
      );
   }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js